import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface TeamFormProps {
    teamName: string;
    onTeamNameChange: (teamName: string) => void;
}

export function TeamForm({teamName, onTeamNameChange}: TeamFormProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-2">
            <Label htmlFor="team-name">{t('admin.teams.createTeam.teamName')} *</Label>
            <Input
                id="team-name"
                value={teamName}
                onChange={(e) => onTeamNameChange(e.target.value)}
                placeholder={t('admin.teams.createTeam.teamNamePlaceholder')}
            />
        </div>
    );
}